var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-img",style:(_vm.imageStyle)},[_c('el-image',{attrs:{"src":require(`@/assets/img/${_vm.img}`),"fit":_vm.fit}}),(_vm.msg)?_c('p',[_vm._v(_vm._s(_vm.msg))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }